/** @format */

import React from 'react';

import {MenuItem} from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import {StyledFormControl, StyledSelect, StyledMenuItem} from '../styles';
import {MENU_PROPS} from '../constants';
import {SelectFieldProps} from '../../../types';

const SelectField = ({
  value,
  onChange,
  options,
  placeholder = 'Выбрать',
  disabled = false,
}: SelectFieldProps) => {
  return (
    <StyledFormControl fullWidth>
      <StyledSelect
        value={value}
        onChange={onChange}
        IconComponent={ArrowDropDownIcon}
        MenuProps={MENU_PROPS}
        displayEmpty
        disabled={disabled}
        renderValue={(selected): React.ReactNode => {
          if (!selected) {
            return placeholder;
          }
          const selectedOption = options.find(option => option.value === selected);
          return selectedOption ? selectedOption.text : String(selected);
        }}
      >
        <MenuItem value='' disabled sx={{color: '#888888 !important'}}>
          {placeholder}
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value} sx={StyledMenuItem}>
            {option.text}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default SelectField;
